module.exports = __webpack_public_path__ + "img/default-theme-left-border.5d125c03.jpg";